export const environmentVariables: any = {
    "ACCOUNT_INFORMATION_LINK": "https://account.dat.com/profile",
    "ANALYTICS_BASE_URL": "https://analytics.api.staging.dat.com",
    "API_BASE_URL": "https://identity.api.staging.dat.com",
    "APP_NAME": "DAT iQ Trendlines",
    "CACHE_BREAKER_QUERY": "trendlines-staging-1.1.2",
    "DATADOG_RUM_APPLICATION_ID": "cf324e8a-dfbf-42af-b36a-a433386d28d5",
    "DATADOG_RUM_CLIENT_TOKEN": "pubcd242f336e1ecb3f424470ea3e1ebe4f",
    "DATADOG_RUM_ENVIRONMENT": "staging",
    "DATADOG_RUM_SERVICE_NAME": "dat-iq-trendlines",
    "DATADOG_RUM_TRACING_URL": "https://analytics.api.staging.dat.com",
    "ENVIRONMENT": "staging",
    "IDENTITY_API_BASE_URL": "https://identity.api.staging.dat.com",
    "IQ_BASE_URL": "https://iq.staging.dat.com",
    "OAUTH2_CONFIG": {
        "client_domain": "login.staging.dat.com",
        "client_id": "GZ7GLUCEWhHPYBeQayrXRvGqCtxOhS4M"
    },
    "OPTIMIZELY_CONFIG": {
        "dataFileUrl": "https://cdn.optimizely.com/datafiles/Bqo7sEwRsxrvGhbgg3rVj.json",
        "fetchPollingSeconds": 20,
        "logLevel": 3,
        "sdkKey": "Bqo7sEwRsxrvGhbgg3rVj"
    },
    "SEGMENT_KEY": "7JaUxdOruP1eMZ93vZvwcdOK4XjWwcw4",
    "X_DAT_DEPLOYMENT": "staging",
    "audience": "https://staging-api.dat.com"
};

